angular.module('picmonicng').directive('sharedPlaylistList', [
  'Schools',
  function (Schools) {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: '/templates/directives/shared-playlist-list.html',
      link: function (scope, element, attrs) {
        scope.loading = true;
        scope.plOrder = [
          { name: 'Popular', value: '-total_users' },
          { name: 'Recent', value: '-created_at' },
        ];
        scope.playlistOrder = scope.plOrder[0];
        scope.limit = attrs.limit;

        scope.playlists = Schools.query(
          {
            school_id: attrs.schoolId,
            resource: 'playlists',
            limit: scope.limit,
          },
          function (data) {
            scope.loading = false;
            scope.playlists = data;
            angular.forEach(scope.playlists, function (key, value) {
              key.users = JSON.parse(key.users);
              if (key.users) {
                key.total_users = key.users.length;
              } else {
                key.total_users = 0;
              }
            });
          }
        );

        scope.setOrder = function (order) {
          scope.playlistOrder = order;
        };
      },
    };
  },
]);
